export const termsSections = [
  {
    title: "第1条（定義）",
    content: [
      "本規約において使用する用語の定義は、以下の通りとします。",
      "1.「ユーザー」とは、本サービスを利用するすべての個人または団体をいいます。",
      "2.「リンク先等」とは、本サービス内に設けられたハイパーリンク等を通じてアクセスされる、第三者が運営するウェブサイトまたはサービスをいいます。",
    ],
  },
  {
    title: "第2条（本規約の適用および同意）",
    content: [
      "本利用規約（以下「本規約」といいます。）は、世田谷区からの委託を受けて提供される「再エネ電気プラン・シミュレーションサービス」（以下「本サービス」といいます。）の利用条件を定めるものであり、本サービスを運営するUCHIKARA事務局（以下「当事務局」といいます。）と、ユーザーとの間に適用されます。",
      "ユーザーは、本サービスを利用することにより、本規約のすべての条項に同意したものとみなされます。",
      "本規約に同意いただけない場合、本サービスをご利用いただくことはできません。",
    ],
  },
  {
    title: "第3条（サービスの内容）",
    content: [
      "本サービスは、再生可能エネルギー100%または実質再生可能エネルギー100%を中心とした家庭向け電力プランについて、世帯人数などの入力情報をもとにシミュレーションを行うウェブサービスです。",
      "本サービスは、世田谷区の委託事業として当事務局のうち、三茶ワークカンパニー(株)が運営しています。",
      "表示される情報は、電力会社から定期的に提供された内容または各社の公開情報に基づいており、常に最新・正確であることを保証するものではありません。",
      "本サービスは、選定・契約の参考情報を提供するものであり、特定の電力会社やプランの選定・契約を助言または推奨するものではありません。",
    ],
  },
  {
    title: "第4条（免責事項）",
    content: [
      "ユーザーは、自己の判断と責任において本サービスを利用するものとし、表示内容に基づいて電力会社と契約を行う際には、必ず各社の公式情報をご確認ください。",
      "本サービスにおいて提示される情報やシミュレーション結果は、一般的な前提条件に基づく参考情報であり、正確性・完全性・最新性について保証するものではありません。",
      "当事務局は、ユーザーが入力した情報および提供元から得た情報をもとに、合理的な注意を払って処理を行いますが、その正確性や完全性を保証するものではなく、情報に誤りが含まれる可能性があることをユーザーは理解したうえで利用するものとします。",
      "表示される料金、契約条件、サービス内容などは、実際の契約と異なる可能性があります。",
      "本サービスのリンク先等は当事務局の管理下にない第三者サイトであり、その内容・利用に起因して生じた損害について当事務局は一切責任を負いません。",
      "本サービスの内容は、予告なく変更・中止・終了することがあります。",
    ],
  },
  {
    title: "第5条（禁止事項および利用制限）",
    content: [
      "ユーザーは、以下の行為を行ってはなりません。",
      "虚偽の情報の入力他者へのなりすまし自動化されたツール等（クローリング、スクレイピング等）による大量アクセスや情報取得法令または公序良俗に反する行為当事務局または第三者の知的財産権、プライバシー、名誉などを侵害する行為その他、当事務局が不適切と判断する行為",
      "当事務局は、上記のいずれかに該当する行為が判明した場合、ユーザーに通知することなく、サービスの全部または一部の利用を停止または制限することができます。",
    ],
  },
  {
    title: "第6条（第三者情報の取扱い）",
    content: [
      "本サービスにおいて表示される情報の一部は、第三者（主に電力会社）から提供されたものに基づいています。",
      "当事務局は、これら第三者提供情報の正確性・完全性・最新性について一切責任を負いません。",
    ],
  },
  {
    title: "第7条（知的財産権）",
    content: [
      "本サービスに含まれるコンテンツ（文章、画像、プログラム等）の著作権その他の知的財産権は、当事務局または正当な権利を有する第三者に帰属します。",
      "ユーザーは、非商用の範囲において、シミュレーション結果等を自由に再利用・共有することができます。その際は出典として本サービス名を明示してください。",
      "商用目的での使用については、事前に当事務局の書面による許諾を得る必要があります。",
    ],
  },
  {
    title: "第8条（ユーザーデータの取扱い）",
    content: [
      "ユーザーが入力した情報（世帯人数・電力使用量・選択したパートナー企業の情報など）は、個人を特定できない形で統計的に処理され、サービスの改善や分析に使用されることがあります。",
      "本サービスは、個人を識別可能な個人情報を取得・保有・利用するものではありません。",
    ],
  },
  {
    title: "第9条（責任の限定）",
    content: [
      "当事務局および世田谷区は、ユーザーによる本サービスの利用または利用不能から生じたいかなる損害（直接的・間接的・偶発的・結果的損害、逸失利益等）についても、当事務局および世田谷区に故意または重過失がある場合を除き、一切の責任を負いません。",
      "ユーザーは、本規約に同意した時点で、これらの免責・責任制限に同意したものとみなされます。",
    ],
  },
  {
    title: "第10条（サービスの変更・中止）",
    content: [
      "当事務局は、ユーザーへの事前通知なく、本サービスの全部または一部を変更、停止または終了することができます。これにより生じた損害についても一切の責任を負いません。",
    ],
  },
  {
    title: "第11条（規約の変更）",
    content: [
      "当事務局は、民法第548条の4に基づき、必要に応じて本規約を変更することがあります。",
      "変更後の規約は、(1)変更内容、(2)効力発生日、(3)ユーザーに与える影響を本サービス上に掲示することにより、効力を生じるものとします。",
      "ユーザーが効力発生日以降も本サービスを継続して利用した場合、変更後の規約に同意したものとみなします。",
    ],
  },
  {
    title: "第12条（準拠法および裁判管轄）",
    content: [
      "本規約の解釈および適用は日本法に準拠し、本サービスに関連する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。",
    ],
  },
];